/*
 * @Author: Yun
 * @Date: 2023-12-08 22:58:51
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-28 09:14:42
 */

import React, { useState, useEffect, useRef, useImperativeHandle } from 'react'
import title from '@images/fourthPage/title.jpg'
import { Swiper, SwiperSlide } from 'swiper/react'
import './index.less'

const FourthPage = (props) => {
    const [pageIndex, setPageIndex] = useState(1)
    const clickEs = () => {
        setPageIndex(1)
    }

    const clickFr = () => {
        setPageIndex(2)
    }

    const clickAr = () => {
        setPageIndex(3)
    }

    const clickRu = () => {
        setPageIndex(4)
    }
    return (
        <div className="fourth-page-mobile">
            <div className="fourth-page-main-wrapper">
                <div className="country-banner-wrapper">
                    {pageIndex == 1 ? (
                        <div
                            className="country-banner-item-active"
                            onClick={() => {
                                clickEs()
                            }}
                        >
                            Español
                        </div>
                    ) : (
                        <div
                            className="country-banner-item"
                            onClick={() => {
                                clickEs()
                            }}
                        >
                            Español
                        </div>
                    )}
                    {pageIndex == 2 ? (
                        <div
                            className="country-banner-item-active"
                            onClick={() => {
                                clickFr()
                            }}
                        >
                            Français
                        </div>
                    ) : (
                        <div
                            className="country-banner-item"
                            onClick={() => {
                                clickFr()
                            }}
                        >
                            Français
                        </div>
                    )}
                    {pageIndex == 3 ? (
                        <div
                            className="country-banner-item-active"
                            onClick={() => {
                                clickAr()
                            }}
                        >
                            العربية
                        </div>
                    ) : (
                        <div
                            className="country-banner-item"
                            onClick={() => {
                                clickAr()
                            }}
                        >
                            العربية
                        </div>
                    )}
                    {pageIndex == 4 ? (
                        <div
                            className="country-banner-item-active"
                            onClick={() => {
                                clickRu()
                            }}
                        >
                            Русский
                        </div>
                    ) : (
                        <div
                            className="country-banner-item"
                            onClick={() => {
                                clickRu()
                            }}
                        >
                            Русский
                        </div>
                    )}
                </div>
                {pageIndex == 1 && (
                    <div className="fourth-page-main">
                        <div className="title-wrapper">
                            <a href="https://espanol.cgtn.com/portada" target="_blank">
                                <div className="title-content">
                                    <div className="title-content-icon"></div>Read more
                                </div>
                            </a>
                        </div>
                        <div className="news-wrapper">
                            <div className="news-content-left">
                                <a
                                    href="https://espanol.cgtn.com/news/2024-01-09/1744608494284484609/index.html"
                                    target="_blank"
                                >
                                    <div className="news-content-left-img es-1"></div>
                                </a>
                            </div>
                            <div className="item-1">
                                <a
                                    href="https://espanol.cgtn.com/news/2024-01-30/1752194843579346945"
                                    target="_blank"
                                >
                                    <div className="item-img es-2"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://espanol.cgtn.com/news/2024-01-30/1752194843579346945"
                                        target="_blank"
                                    >
                                        Una senda propia: Un rumbo sostenible
                                    </a>
                                </div>
                            </div>
                            <div className="item-2">
                                <a
                                    href="https://espanol.cgtn.com/news/2024-02-11/1756499652922929154"
                                    target="_blank"
                                >
                                    <div className="item-img es-3"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://espanol.cgtn.com/news/2024-02-11/1756499652922929154"
                                        target="_blank"
                                    >
                                        Una senda propia: La brújula del desarrollo...
                                    </a>
                                </div>
                            </div>
                            <div className="item-3">
                                <a
                                    href="https://espanol.cgtn.com/news/2024-10-30/1851453587592437761"
                                    target="_blank"
                                >
                                    <div className="item-img es-4"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://espanol.cgtn.com/news/2024-10-30/1851453587592437761"
                                        target="_blank"
                                    >
                                        Ecos del Desarrollo: Testigos de la...
                                    </a>
                                </div>
                            </div>
                            <div className="item-4">
                                <a
                                    href="https://espanol.cgtn.com/news/2024-11-16/1857695045515575297"
                                    target="_blank"
                                >
                                    <div className="item-img es-5"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://espanol.cgtn.com/news/2024-11-16/1857695045515575297"
                                        target="_blank"
                                    >
                                        Ecos del Desarrollo: A través de...
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {pageIndex == 2 && (
                    <div className="fourth-page-main">
                        <div className="title-wrapper">
                            <a href="https://francais.cgtn.com/home" target="_blank">
                                <div className="title-content">
                                    <div className="title-content-icon"></div>Read more
                                </div>
                            </a>
                        </div>
                        <div className="news-wrapper">
                            <div className="news-content-left">
                                <a
                                    href="https://francais.cgtn.com/news/2024-08-30/1829465609308745729/index.html"
                                    target="_blank"
                                >
                                    <div className="news-content-left-img fr-1"></div>
                                </a>
                            </div>
                            <div className="item-1">
                                <a
                                    href="https://francais.cgtn.com/news/2024-09-01/1830167940134539265/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img fr-2"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://francais.cgtn.com/news/2024-09-01/1830167940134539265/index.html"
                                        target="_blank"
                                    >
                                        LETTRE DE RÉPONSE : Maîtriser...
                                    </a>
                                </div>
                            </div>
                            <div className="item-2">
                                <a
                                    href="https://francais.cgtn.com/news/2024-09-03/1830872546818666498/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img fr-3"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://francais.cgtn.com/news/2024-09-03/1830872546818666498/index.html"
                                        target="_blank"
                                    >
                                        Lettre de réponse : comprendre les spécificités...
                                    </a>
                                </div>
                            </div>
                            <div className="item-3">
                                <a
                                    href="https://francais.cgtn.com/news/2024-09-05/1831540398552977410/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img fr-4"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://francais.cgtn.com/news/2024-09-05/1831540398552977410/index.html"
                                        target="_blank"
                                    >
                                        Lettre de réponse : les groupes de réflexion...
                                    </a>
                                </div>
                            </div>
                            <div className="item-4">
                                <a
                                    href="https://francais.cgtn.com/news/2024-11-08/1854774859656343553/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img fr-5"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://francais.cgtn.com/news/2024-11-08/1854774859656343553/index.html"
                                        target="_blank"
                                    >
                                        Lettre de réponse : Que l'essence de toutes...
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {pageIndex == 3 && (
                    <div className="fourth-page-main">
                        <div className="title-wrapper">
                            <a href="https://arabic.cgtn.com/home" target="_blank">
                                <div className="title-content">
                                    <div className="title-content-icon"></div>Read more
                                </div>
                            </a>
                        </div>
                        <div className="news-wrapper">
                            <div className="news-content-left">
                                <a
                                    href="https://arabic.cgtn.com/news/2024-05-26/1794448418009292801/index.html"
                                    target="_blank"
                                >
                                    <div className="news-content-left-img ar-1"></div>
                                </a>
                            </div>
                            <div className="item-1">
                                <a
                                    href="https://arabic.cgtn.com/news/2024-05-26/1794448661381627905/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img ar-2"></div>
                                </a>
                                <div className="item-content rtl">
                                    <a
                                        href="https://arabic.cgtn.com/news/2024-05-26/1794448661381627905/index.html"
                                        target="_blank"
                                    >
                                        جسور المحبة: الري الذكي.. تبشير بالحصاد
                                    </a>
                                </div>
                            </div>
                            <div className="item-2">
                                <a
                                    href="https://arabic.cgtn.com/news/2024-06-14/1801397008659103746/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img ar-3"></div>
                                </a>
                                <div className="item-content rtl">
                                    <a
                                        href="https://arabic.cgtn.com/news/2024-06-14/1801397008659103746/index.html"
                                        target="_blank"
                                    >
                                        جسور المحبة: رحلتي إلى الشرق
                                    </a>
                                </div>
                            </div>
                            <div className="item-3">
                                <a
                                    href="https://arabic.cgtn.com/news/2024-05-28/1794449597776773122/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img ar-4"></div>
                                </a>
                                <div className="item-content rtl">
                                    <a
                                        href="https://arabic.cgtn.com/news/2024-05-28/1794449597776773122/index.html"
                                        target="_blank"
                                    >
                                        جسور المحبة: الأصفر والأخضر.. من المواجهة إلى التعايش
                                    </a>
                                </div>
                            </div>
                            <div className="item-4">
                                <a
                                    href="https://arabic.cgtn.com/news/2024-05-29/1794449858549235714/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img ar-5"></div>
                                </a>
                                <div className="item-content rtl">
                                    <a
                                        href="https://arabic.cgtn.com/news/2024-05-29/1794449858549235714/index.html"
                                        target="_blank"
                                    >
                                        جسور المحبة: مدينة المستقبل
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {pageIndex == 4 && (
                    <div className="fourth-page-main">
                        <div className="title-wrapper">
                            <a href="https://russian.cgtn.com/home" target="_blank">
                                <div className="title-content">
                                    <div className="title-content-icon"></div>Read more
                                </div>
                            </a>
                        </div>
                        <div className="news-wrapper">
                            <div className="news-content-left">
                                <a
                                    href="https://russian.cgtn.com/news/2024-12-06/1864861031838457858/index.html"
                                    target="_blank"
                                >
                                    <div className="news-content-left-img ru-1"></div>
                                </a>
                            </div>
                            <div className="item-1">
                                <a
                                    href="https://russian.cgtn.com/news/2024-12-06/1864862163264544770/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img ru-2"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://russian.cgtn.com/news/2024-12-06/1864862163264544770/index.html"
                                        target="_blank"
                                    >
                                        Зампредседателя ЦК КПРФ: государственный...
                                    </a>
                                </div>
                            </div>
                            <div className="item-2">
                                <a
                                    href="https://russian.cgtn.com/news/2024-12-06/1864863391264481281/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img ru-3"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://russian.cgtn.com/news/2024-12-06/1864863391264481281/index.html"
                                        target="_blank"
                                    >
                                        Эксперт рассказал о китайском пути...
                                    </a>
                                </div>
                            </div>
                            <div className="item-3">
                                <a
                                    href="https://russian.cgtn.com/news/2024-12-06/1864864027925192706/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img ru-4"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://russian.cgtn.com/news/2024-12-06/1864864027925192706/index.html"
                                        target="_blank"
                                    >
                                        Эксперт: и в древности, и сейчас...
                                    </a>
                                </div>
                            </div>
                            <div className="item-4">
                                <a
                                    href="https://russian.cgtn.com/news/2024-12-06/1864864862562328577/index.html"
                                    target="_blank"
                                >
                                    <div className="item-img ru-5"></div>
                                </a>
                                <div className="item-content">
                                    <a
                                        href="https://russian.cgtn.com/news/2024-12-06/1864864862562328577/index.html"
                                        target="_blank"
                                    >
                                        Эксперт: справедливое и гармоничное...
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default FourthPage
